InitLoadEvents = function () {
    var init = function () {
        $('#load-upcoming').click(function (e) {
            e.preventDefault();
            $.ajax({
                url: 'LoadAdditionalUpcomingEvents',
                data: { contentLink: $(this).attr('data-page-reference') }
            }).done(function (data) {
                $('#load-upcoming').css("display", "none");
                $('.eventlisting-page_upcoming-events .content .grid').append(data);
            });
        });
        $('#load-outdated').click(function (e) {
            e.preventDefault();
            console.log($(this).attr('data-page-reference'));
            $.ajax({
                url: 'LoadAdditionalOutdatedEvents',
                data: { contentLink: $(this).attr('data-page-reference'), eventCategory: $(this).attr('data-eventCategory'), groupCategory: $(this).attr('data-groupCategory') }
            }).done(function (data) {
                $('#load-outdated').css("display", "none");
                $('.eventlisting-page_outdated-events_content .grid').append(data);
            });
        });

    /* EventListing Page Check if user is on Mac and uses Chrome */

        var OSName = "Unknown OS";
        if (navigator.appVersion.indexOf("Win") != -1) OSName = "Windows";
        if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MacOS";
        if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
        if (navigator.appVersion.indexOf("Linux") != -1) OSName = "Linux";

        var nAgt = navigator.userAgent;
        var browserName = navigator.appName;
        if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
            browserName = "Chrome";
            fullVersion = nAgt.substring(verOffset + 7);
        }

        if (OSName == "MacOS" && browserName == "Chrome") {
            // Lägg till en ny klass på .eventlisting-page__button
            $('.eventlisting-page__button').addClass('eventlisting-page__button__adjustment-mac-chrome');
            // Och lägg till en ny klass på #category och #group
            $('#category').addClass('events_filter__adjustment-mac-chrome');
            $('#group').addClass('events_filter__adjustment-mac-chrome');
        }
        else if (OSName == "MacOS" && browserName == "Safari") {
            // Lägg till en ny klass på .eventlisting-page__button
            $('.eventlisting-page__button').addClass('eventlisting-page__button__adjustment-mac-safari');
            // Och lägg till en ny klass på #category och #group
            $('#category').addClass('events_filter__adjustment-mac-safari');
            $('#group').addClass('events_filter__adjustment-mac-safari');
        }

    };
    return {
        init: init
    };
}();